import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import history from '../../../history';
import { messages } from './PinRequired.i18n';
import { setIsDedicatedWorkflow } from '../../../redux/modules/workflow/workflow-action-creator';
import * as MsgBarActions from '../../../redux/modules/system-shared/message-bar-action-creator';
import { setAuthRepInvitation } from '../../../redux/modules/ar-invitation/ar-invitation-action-creator';
import { getPinPdfUrl } from '../../../redux/modules/ar-invitation/ar-invitation-middleware';

class PinRequired extends React.Component {
  getBaseUrl = () =>
    ('//'.concat(window.equicareLocalConfiguration.apiUrl.hostname).concat(':')
      .concat(window.equicareLocalConfiguration.apiUrl.port));

  clickDoneButton = () => {
    this.props.dispatch(MsgBarActions.showStickySuccessMessage('contactInviteSuccess'));
    this.props.dispatch(setIsDedicatedWorkflow(false));
    this.props.dispatch(setAuthRepInvitation({}));
    history.push('/');
  }

  handlePrintButtonClick = (event) => {
    const {
      dispatch,
      invitationId,
    } = this.props;

    event.preventDefault();
    dispatch(getPinPdfUrl(invitationId))
      .then((url) => {
        window.open(this.getBaseUrl() + url);
      });
  }

  render() {
    const contact = this.props.personalContacts.find((member) => member.contactId === this.props.contactId);

    if (contact) {
      return (
        <div>
          <div className="content-area">
            <p className="card-text" aria-describedby="emailMessage" id="emailMessage" tabIndex="0" >
              <FormattedMessage values={{ email: contact.contactEmail }} {...messages.page.emailMessage} />
            </p>
            <p id="pageInstruction" tabIndex="0">
              <FormattedMessage { ...messages.page.instruction } />
            </p>
            <p className="pin center" tabIndex="0"><FormattedMessage { ...messages.label.pin } />
              {this.props.pin}
            </p>
            <p className="card-text text-center bold mb-3" tabIndex="0">
              <FormattedMessage values={{ firstName: contact.contactFirstName, lastName: contact.contactLastName }}
                {...messages.page.note}
              />
            </p>
          </div>
          <form>
            <div className="button-area">
              <button className="btn btn-primary mr-1"
                aria-describedby="button_description"
                data-qa-item="print_button"
                onClick={this.handlePrintButtonClick}
              >
                <FormattedMessage {...messages.button.print} />
              </button>
              <button className="btn btn-outline-secondary"
                aria-describedby="button_description"
                onClick={ this.clickDoneButton }
                data-qa-item="done_button"
              >
                <FormattedMessage {...messages.button.done} />
              </button>
            </div>
          </form>
        </div>
      );
    }

    return null;
  }
}

PinRequired.propTypes = {
  dispatch: PropTypes.func,
  personalContacts: PropTypes.array,
  contactId: PropTypes.string,
  pin: PropTypes.string,
  invitationId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  personalContacts: state.personalContacts.personalContacts,
  contactId: state.personalContacts.selectedContactId,
  invitationId: state.invitation.arInvitation.invitationId,
});

export default connect(mapStateToProps)(PinRequired);